// state update enum
export const UPDATE_DYNAMIC_STATE = 0;

export const updateDynamicStateAction = (newState) => ({
    type: UPDATE_DYNAMIC_STATE,
    payload: newState
});


export const mapDispatchToProps = (dispatch) => ({
	updateDynamicState: (newState) => dispatch(updateDynamicStateAction(newState))
});
